import type { EffectParams } from '@swf/core/store';

const acceptRacesTerms = async (version: number, { dispatch, request }: EffectParams) => {
  try {
    await request({ service: 'casino.races.acceptTerms', body: { version } });
    dispatch.modal.close('/casino/help');
    dispatch.casino.set({ racesTermsVersionAccepted: version });
  } catch {
    dispatch.modal.close('/casino/help');
  }
};

export default acceptRacesTerms;
